import { VehicleReview, VehicleReviewData } from "./vehicle-review-data.interfaces";

export interface VehicleRatingsSummaryData {
  avgPerformance: number;
  avgPower: number;
  avgStability: number;
  avgDesign: number;
}

export interface VehicleReviewSummaryData {
  count: number;
  averageRatings: VehicleRatingsSummaryData;
  data: VehicleReviewData[];
}

export class VehicleReviewSummary implements VehicleReviewSummaryData {
  count: number;
  averageRatings: VehicleRatingsSummaryData;
  data: VehicleReview[];

  constructor(_: VehicleReviewSummary) {
    this.count = _.count;
    this.averageRatings = _.averageRatings;
    this.data = _.data.map(review => new VehicleReview(review));
  }

  getGlobalRating() {
    return (
      this.getPerformanceRating() +
      this.getPowerRating() +
      this.getStabilityRating() +
      this.getDesignRating()
    ) / 4;
  }

  getTotalReviews() {
    return this.count;
  }

  getPerformanceRating(): number {
    return this.averageRatings.avgPerformance;
  }

  getPowerRating(): number {
    return this.averageRatings.avgPower;
  }

  getStabilityRating(): number {
    return this.averageRatings.avgStability;
  }

  getDesignRating(): number {
    return this.averageRatings.avgDesign;
  }
}
